import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = (theme: typeof muiTheme) => ({
    secretsContainer: {
        width: '70%',
        paddingBottom: '30px'
    },
    textContainer: {
        width: '85%',
        paddingBottom: '20px',
        textAlign: 'center' as 'center'
    },
    iconsContainer: { heigth: '100%' },
    showSecretsIcon: {
        cursor: 'pointer' as 'pointer',
        paddingTop: '4px'
    },
    hideSecretsIcon: {
        cursor: 'pointer' as 'pointer',
        paddingTop: '8px'
    },
    field: {
        display: 'flex',
        width: '100%',
        flexFlow: 'column nowrap'
    },
    inputLabel: {
        color: theme?.app?.applicationColors.enumColors.grey || '#4a4a4a',
        fontSize: '.8rem',
        marginBottom: '.3rem',
        fontFamily: 'corporate-s,sans-serif'
    },
    textInput: {
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333',
        height: '2.75rem',
        width: '100%',
        fontFamily: 'corporate-s,sans-serif',
        fontSize: '14px',
        padding: '0 .45rem',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}`,
        borderRadius: '3px'
    },
    inputContainer: {
        position: 'relative' as const,
        display: 'inline-flex' as const
    }
});